import { render, staticRenderFns } from "./abroad-captical.vue?vue&type=template&id=5887ef92&scoped=true&"
import script from "./abroad-captical.vue?vue&type=script&lang=js&"
export * from "./abroad-captical.vue?vue&type=script&lang=js&"
import style0 from "./abroad-captical.vue?vue&type=style&index=0&id=5887ef92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887ef92",
  null
  
)

export default component.exports